"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var config_1 = require("../config");
var proximaNova = {
    fontFamily: 'ProximaNova',
    fontStyle: 'normal',
    fontDisplay: 'swap'
};
var proximaNovaRegular = tslib_1.__assign(tslib_1.__assign({}, proximaNova), { fontWeight: 400, src: "local('Proxima Nova Regular'), local('ProximaNova-Regular'), url('" + config_1.STATIC_ASSETS_URL + "/fonts/ProximaNova-Regular.woff')" });
var proximaNovaSemiBold = tslib_1.__assign(tslib_1.__assign({}, proximaNova), { fontWeight: 600, src: "local('Proxima Nova Semibold'), local('ProximaNova-Semibold'), url('" + config_1.STATIC_ASSETS_URL + "/fonts/ProximaNova-Semibold.woff')" });
var proximaNovaBold800 = tslib_1.__assign(tslib_1.__assign({}, proximaNova), { fontWeight: 800, src: "local('Proxima Nova Bold'), local('ProximaNova-Bold'), url('" + config_1.STATIC_ASSETS_URL + "/fonts/ProximaNova-Bold.woff')" });
var proximaNovaBold = tslib_1.__assign(tslib_1.__assign({}, proximaNova), { fontWeight: 'bold', src: "local('Proxima Nova Bold'), local('ProximaNova-Bold'), url('" + config_1.STATIC_ASSETS_URL + "/fonts/ProximaNova-Bold.woff')" });
exports["default"] = [
    proximaNovaRegular,
    proximaNovaSemiBold,
    proximaNovaBold800,
    proximaNovaBold
];
//# sourceMappingURL=fonts.js.map